import React from 'react';
import PropTypes from 'prop-types';
import './number-card.scss';
import Tooltip from '../tooltip/tooltip';
import { InfoBlueGradientIcon } from '../icons/icons';
import NumberCardInfo from '../number-card-info/number-card-info';

/**
 * @typedef {'small' | 'medium' | 'large'} SizeType - Size choices for the component.
 */

/**
 * Component to demonstrate different sizes, appearances, and popup options.
 * @param {Object} props
 * @param {SizeType} props.size
 * @returns {JSX.Element}
 */
function NumberCard({
  value,
  status,
  content,
  size,
  title,
  mode,
  enableInfo,
  modes,
  multiple,
}) {
  const sizeProperties = {
    small: 'small',
    medium: 'medium',
    large: 'large',
  };
  const sizeProps = sizeProperties[size];
  return (
    <span className={`number-card ${status} ${sizeProps}`}>
      {enableInfo && (
        <NumberCardInfo
          title={title}
          mode={mode}
          value={value}
          modes={modes}
          multiple={multiple}
        >
          <InfoBlueGradientIcon size="0.556vw" />
        </NumberCardInfo>
      )}

      {value != null &&
        (typeof value === 'number' || typeof value === 'string') && (
          <Tooltip content={content}>{value}</Tooltip>
        )}
      {value != null && typeof value === 'object' && (
        <Tooltip content={content}>{value.value}</Tooltip>
      )}
    </span>
  );
}

export default NumberCard;
NumberCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  status: PropTypes.string,
  content: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string,
  mode: PropTypes.string,
  enableInfo: PropTypes.bool,
  modes: PropTypes.instanceOf(Object),
  multiple: PropTypes.bool,
};
NumberCard.defaultProps = {
  value: 0,
  status: '',
  content: '',
  size: 'medium',
  title: '',
  mode: '',
  enableInfo: false,
  modes: {},
  multiple: false,
};
